var Uniform = /*#__PURE__*/function () {
  function Uniform(value) {
    if (typeof value === 'string') {
      console.warn('THREE.Uniform: Type parameter is no longer needed.');
      value = arguments[1];
    }

    this.value = value;
  }

  var _proto = Uniform.prototype;

  _proto.clone = function clone() {
    return new Uniform(this.value.clone === undefined ? this.value : this.value.clone());
  };

  return Uniform;
}();

export { Uniform };